import React, { FC } from 'react';

import { useUser } from '@adsk/alloy-provider';

import { useSetDynatraceUser } from '../../hooks/useSetDynatraceUser';
import { AnalyticsInitializer } from '../Analytics/AnalyticsInitializer';

export const AuthenticationListener: FC = () => {
  const { user } = useUser();

  useSetDynatraceUser(user?.analyticsId);

  if (!user) {
    return null;
  }

  return <AnalyticsInitializer />;
};
